import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { FaChevronLeft } from "react-icons/fa";
import ProviderSettingsTab from "../../components/ProviderSettingsTab";
import { markSectionVisited } from "../../utils/providerOnboarding";
import "../../components/ProviderDetails.css";
import classes from "./SettingsOnboarding.module.css";

const SettingsOnboarding = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state?.user?.user);
  const providerId = user?.providerId;

  const [provider, setProvider] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadData = useCallback(async () => {
    if (!providerId) {
      setLoading(false);
      setError("Provider profile not found.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const providerRes = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/specialist/provider/${providerId}`,
        user?.token
          ? { headers: { Authorization: `Bearer ${user.token}` } }
          : undefined,
      );

      if (!providerRes.data?.success) {
        setError(providerRes.data?.message || "Failed to load settings.");
        return;
      }

      setProvider(providerRes.data.data);
      markSectionVisited("settings", providerId);
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to load settings information.",
      );
    } finally {
      setLoading(false);
    }
  }, [providerId, user?.token]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  if (loading) {
    return <div className={classes.loading}>Loading settings...</div>;
  }

  if (error || !provider) {
    return (
      <div className={classes.error}>
        {error || "Unable to load settings."}
      </div>
    );
  }

  return (
    <div className={classes.page}>
      <div className={classes.header}>
        <button
          type="button"
          className={classes.backBtn}
          aria-label="Back to onboarding"
          onClick={() => navigate("/dashboard")}
        >
          <FaChevronLeft />
        </button>
        <div>
          <h1 className={classes.title}>Settings</h1>
          <p className={classes.subtitle}>
            Configure referrals, notifications, and account preferences.
          </p>
        </div>
      </div>

      <div className={classes.content}>
        <ProviderSettingsTab
          provider={provider}
          getProviderId={() => providerId}
          onProviderUpdated={(next) => setProvider(next)}
        />
      </div>
    </div>
  );
};

export default SettingsOnboarding;
